import { HttpMethod } from '@/types/HttpMethod';
import { PhotoStatusDTO } from '@/types/photostatus/PhotoStatusDTO';
import { PhotoStatusImageDTO } from '@/types/photostatus/PhotoStatusImageDTO';
import { apiSlice } from '@/services/api/apiSlice';

/**
 * The public photo-status page, reached through the 30-day link of the notification
 * announcing that some photos of a letter did not pass censorship. The link token is the
 * only authorisation the caller has, so it travels with every request.
 */
export const photoStatusApiSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getPhotoStatus: build.query<PhotoStatusDTO, string>({
      query: (photoStatusToken: string) => ({
        url: '/letter/photo-status',
        method: HttpMethod.GET,
        params: {
          photoStatusToken: photoStatusToken,
        },
      }),
    }),
    getPhotoStatusImage: build.mutation<PhotoStatusImageDTO, { photoStatusToken: string; photoId: number }>({
      query: (request: { photoStatusToken: string; photoId: number }) => ({
        url: '/letter/photo-status/photo',
        method: HttpMethod.GET,
        params: {
          photoStatusToken: request.photoStatusToken,
          photoId: request.photoId,
        },
      }),
    }),
  }),
});

export const { useGetPhotoStatusQuery, useGetPhotoStatusImageMutation } = photoStatusApiSlice;
